export enum InvoiceStatus {
	Loading = '',
	Draft = 'draft',
	Sent = 'sent',
	Viewed = 'viewed',
	PartialPaid = 'partial-paid',
	Paid = 'paid',
	Refunded = 'refunded',
	Deleted = 'deleted'
}

export const allStatuses = [
	InvoiceStatus.Draft,
	InvoiceStatus.Sent,
	InvoiceStatus.Viewed,
	InvoiceStatus.PartialPaid,
	InvoiceStatus.Paid,
	InvoiceStatus.Refunded
]

export enum InvoiceStatusFilter {
	All = 'all',
	Unsent = 'unsent',
	Sent = 'sent',
	Paid = 'paid',
	PartialPaid = 'partial-paid',
	Owing = 'owing',
	Overdue = 'overdue',
	Refunded = 'refunded',
	Archived = 'archived'
}

export type InvoicesParams = {
	statuses: InvoiceStatus[]
	archived: boolean[]
	query: string
	invoiceId: string

	clientId: string
	itemId: string
	invoices_filter: string

	date_start: Date | null
	date_end: Date | null
}

export function getDefaultInvoicesParams() {
	return {
		statuses: allStatuses,
		archived: [false],
		query: '',
		invoiceId: '',

		clientId: '',
		itemId: '',
		invoices_filter: '',

		date_start: null,
		date_end:  null
	}
}


export type InvoiceListItem = {
	archived: boolean
	balance: Big
	client_email: string
	client_id: string
	client_name: string
	deposit_due: Big
	due: string // DATE due
	id: string
	issued: string
	number: string
	payment: Big
	status: InvoiceStatus
	created_at: number
	updated_at: number
	archived_at: number | null
	last_sent_at: number | null
	last_viewed_at: number | null
	last_paid_at: number | null
	last_refunded_at: number | null
	last_deleted_at: number | null
	currency_id: string
}